function calculatePrices() {
  //count how many positions are now selected
  var count = $('input[name="selected_position[]"]:checked').length;
  var cartid = $('input[name="cartid"]').val();
  var customiseid = $('input[name="customisation_id"]').val();
  var bundleid = $('input[name="bundleid"]').val();
  var method = $('input[name="method"]:checked').val();
  var logo_or_text = $('input[name="logo_or_text"]:checked').val();
  var existing_image = $('input[name="image[existing_id]"]:checked').length;
  var force_remove_setup_fee = 0;
  var cartKeysString = $('input[name="cartKeys"]').val() ?? 0;

  var textFont = $('input[name="text[chosen_text_font]"]').val();
  var textColour = $('input[name="text[chosen_text_colour]"]').val();
  var textElements = $('input[name^="text[type_text]"]');
  var textValuesArray = [];
  textElements.map(function() {
      textValuesArray.push($(this).val());
  });


  //add preloader
  $('.preloader').css('display', 'block');

  //Check if any current uploaded session images have been selected
  $('.customise__currentuploaded img.selected').each(function() {
    force_remove_setup_fee = 1;
  });

  //update prices based on positions selected
  $.ajax({
    type: 'POST',
    url: $(document.body).data('base') + '/ajax/customisation/calculate-prices.php',
    data: {
      cartid: cartid,
      bundleid: bundleid,
      count: count,
      method: method,
      logo_or_text: logo_or_text,
      existing_image: existing_image,
      force_free_setup: force_remove_setup_fee,
      text_customisation: textValuesArray,
      text_font: textFont,
      text_colour: textColour,
      customise_id: customiseid,
      cartKeys: cartKeysString
    },
    success: function(response) {
      response = JSON.parse(response);

      if(response.status !== 'success') {
        swal({
          title: '', 
          text: response.message, 
          type: response.status,
          confirmButtonColor: "#f15a24"
        });
      } 
      else {
          $('.customise__right .price-list .application-fees .price').html(response.application_fees+'<span>/ Per Garment</span>');
          $('.customise__right .price-list .total-price .price').html(response.total);
          $('.customise__right .price-list .each-item .price').html(response.individual_total);
          $('.customise__right .price-list .setup-fee .price').html(response.setup_fee);
          $('.preloader').css('display', 'none');
      }
    }
  });
}

$(document).ready(function() {
// Customisation functionality
// Core functions and submission 
calculatePrices();
$('form[name="customisation_form"]').validate({
  ignore: [],
  rules: {
    method: {
      required: true
    },
    logo_or_text: {
      required: true
    },
    'text[type_text][1]': {
      required: function() {
        return $('input[name="logo_or_text"]:checked').val() === 'text';
      }
    },
    'text[chosen_text_colour]': {
      required: function() {
        return $('input[name="logo_or_text"]:checked').val() === 'text';
      }
    },
    'text[chosen_text_font]': {
      required: function() {
        return $('input[name="logo_or_text"]:checked').val() === 'text';
      }
    },
    'image[uploaded_image_url]': {
      required: function() {
        if ( $('input[name="image[existing_id]"]:checked').length <= 0 ) {
          return $('input[name="logo_or_text"]:checked').val() === 'image';
        }
      }
    },
    'selected_position[]': {
      required: true
    }
  },
  messages: {
    method: "Please select either Print or Embroidery.",
    logo_or_text: "Please select either Logo or Text.",
    'text[type_text][1]': "You have chosen to use custom text but not entered any text.",
    'text[chosen_text_colour]': "Please choose the colour of your text.",
    'text[chosen_text_font]': "Please choose the font of your text.",
    'image[uploaded_image_url]': "You have chosen to use an image but not selected an image.",
    'selected_position[]': "Please select atleast 1 position."
  },
  errorPlacement: function(error, element) {
    if (element.attr("name") == "image[uploaded_image_url]" )
      error.appendTo("#image-error-placement");
    else if  (element.attr("name") == "text[type_text][1]" )
      error.appendTo("#text-error-placement");
    else if  (element.attr("name") == "text[chosen_text_font]" )
      error.appendTo("#text-error-placement");
    else if  (element.attr("name") == "text[chosen_text_colour]" )
      error.appendTo("#text-error-placement");
    else if  (element.attr("name") == "selected_position[]" )
      error.appendTo("#position-error-placement");
    else
      error.insertAfter(element);
  },
  focusInvalid: false,
  invalidHandler: function(form, validator) {
    if (!validator.numberOfInvalids())
      return;

    swal({
      title: '',
      type: 'error',
      text: 'Your customisation could not be added. Please double check you have entered all the required fields.',
      confirmButtonColor: "#f15a24"
    });
  },
  submitHandler: function() {
    //add preloader
    $('.preloader').css('display', 'block');
    $.ajax({
      type: 'POST',
      url: $(document.body).data('base') + '/ajax/customisation/add-customisation-to-cart.php',
      data: $('form[name="customisation_form"]').serialize(),
      success: function(response) {
          response = JSON.parse(response);
          swal({
            title:'',
            text: response.message,
            type: response.status,
            confirmButtonColor: "#f15a24"
          }, function() {
              if('success' == response.status ) {
                if(response.redirect_url == 'preset') {
                  window.opener.location.reload();
                  window.close();
                } else if(response.redirect_url == 'admin') {
                  window.close();
                } else {
                  window.location.href = $(document.body).data('base') + response.redirect_url;
                }
              }
          });
          //remove preloader
          $('.preloader').css('display', 'none');
      },
      error: function() {
          console.log('Ajax request not received');
      }
    });

    return false;
  }
});

  $('.bundle-logo-or-text').on('click', function () {
    var checkbox = $(this).next('input[name="customisation[logo_or_text]"]');

    $('input[name="customisation[logo_or_text]"]').each(function(){
      if ( $(this).is(":checked") ) {
        $(this).prop('checked', false);
      }
    })

    checkbox.prop('checked', true);

    calculatePrices();
  })

  $('.logo-or-text').on('click', function () {
    var checkbox = $(this).prev('input[name="logo_or_text"]');

    $('input[name="logo_or_text"]').each(function(){
      if ( $(this).is(":checked") ) {
          $(this).prop('checked', false); 
      }
    })

    checkbox.prop('checked', true);

    calculatePrices();
  })

  $('input[name="text[chosen_text_colour]"]').on('change', function () {
    calculatePrices();
  });

  $('input[name="text[chosen_text_font]"]').on('change', function () {
    calculatePrices();
  });

  var textTypingTimer;               
  var doneTextTypingInterval = 500; 
  //on keyup, start the countdown
  $('.form__textarea--insert-text').keyup(function () {
      clearTimeout(textTypingTimer);
      if ($('.form__textarea--insert-text').val()) {
        textTypingTimer = setTimeout(doneTextTyping, doneTextTypingInterval);
      }
  });

  function doneTextTyping() {
    calculatePrices();
  }

  $('.customise__list-item:not(.customise__list-item--unavailable) img').on('click', function () {
    var checkbox = $(this).parent().find('input[type="checkbox"]');

    if ( $(this).parent().hasClass('selected') ) {
      checkbox.prop('checked', false);
    } else {
      checkbox.prop('checked', true);
    }

    calculatePrices();
  });
  
  $('input[name="method"]').on('change', function(event) {
    calculatePrices();
  })

$('.form__button--upload, .form__input--upload').unbind('click').bind('click', function(e) {
  e.preventDefault();
  if ( $('.customise__currentuploaded img').length ) {
    //if images exist in session, remind user uploading will incur a fee.
    swal({
        title: 'Don\'t forget...',
        text: 'Uploading a new image will include a setup fee. You can select an existing image to avoid the charge.',
        type: 'info',
        confirmButtonColor: "#f15a24"
    }, function () {
        $('.hidden-image-input').trigger('click');
    });

  } else {
    $('.hidden-image-input').trigger('click');
  }
});

$('.hidden-image-input').change(function() {
  var value = $(this).val();
  var newValue = value.replace(/^.*\\/, "");
  var customFileUpload = $('.form__input--upload');

  $( customFileUpload.val(newValue) );
  $('.form__button--upload').html('Change');
});

$('.submit-customisation-upload').on('click', function () {

  $('form[name="customisation_form"]').ajaxSubmit({
    type: 'post',
    url: $(document.body).data('base') +'/ajax/customisation/customisation-upload.php',
    data: $('form[name="customisation_form"]').serializeObject(),
    success: function (responseData) {
      var $response = JSON.parse(responseData);
      if (typeof $response === 'object' && $response !== null && $response['status'] !== 'success') {
        swal({
          title: $response['status'], 
          text: $response['message'],
          type: $response['status'],
          confirmButtonColor: "#f15a24"
        });
      } else {
        swal({
          title: $response['title'],
          text: $response['message'],
          type: $response['status'],
          confirmButtonColor: "#f15a24"
        });
        $('input[name="image[uploaded_image_url]"]').val($response['image_url']);
        $('.uploaded_preview').attr('src', $response['image_url']);

        if ( $('.uploaded_preview').hasClass('hidden') ) {
          $('.uploaded_preview').removeClass('hidden');
        }

        //deselect existing images if one is uploaded
        $('input[name="image[existing_id]"]').each(function(){
          if ( $(this).is(":checked") ) {
              $(this).prop('checked', false); 
          }
        })
        $('.upload__right .customise__button.selected').removeClass('selected');
        $('.customise__currentuploaded img.selected').each(function() {
          $(this).removeClass('selected');
        })

        calculatePrices();
      }   
    },
    error: function (responseData) {
        console.log('Ajax request not recieved!');
    }
  });

});

$('.submit-bundle-customisation-upload').on('click', function () {

    $('form[name="customisation_form"]').ajaxSubmit({
      type: 'post',
      url: $(document.body).data('base') +'/ajax/customisation/customisation-upload.php',
      data: $('form[name="customisation_form"]').serializeObject(),
      success: function (responseData) {
        var $response = JSON.parse(responseData);
        if (typeof $response === 'object' && $response !== null && $response['status'] !== 'success') {
          swal({
            title: $response['status'],
            text: $response['message'],
            type: $response['status'],
            confirmButtonColor: "#f15a24"
          });
        } else {
          swal({
            title: $response['title'],
            text: $response['message'],
            type: $response['status'],
            confirmButtonColor: "#f15a24"
          });
          $('input[name="customisation[image][uploaded_image_url]').val($response['image_url']);
          $('.uploaded_preview').attr('src', $response['image_url']);

          if ( $('.uploaded_preview').hasClass('hidden') ) {
            $('.uploaded_preview').removeClass('hidden');
          }

          $('.upload__right .customise__button.selected').removeClass('selected');
          $('.customise__currentuploaded img.selected').each(function() {
            $(this).removeClass('selected');
          })

          calculatePrices();
        }
      },
      error: function (responseData) {
        console.log('Ajax request not recieved!');
      }
    });

  });

$('.customisation-login').on('click', function(e) {
  e.preventDefault();

  $('form[name="customisation_form"]').ajaxSubmit({
    type: 'post',
    url: $(document.body).data('base') +'/ajax/customisation/login.php',
    data: $('form[name="customisation_form"]').serializeObject(),
    success: function (responseData) {
      var $response = JSON.parse(responseData);
      if (typeof $response === 'object' && $response !== null && $response['status'] !== 'success') {
        swal({
          title: $response['status'], 
          text: $response['message'],
          type: $response['status'],
          confirmButtonColor: "#f15a24"
        });
      } else {
        swal({
          title: $response['status'], 
          text: $response['message'],
          type: $response['status'],
          confirmButtonColor: "#f15a24"
        });
        //re-render block to display saved images
        setTimeout(function(){
          $('.customisation-login-form').remove();
          $('.render-customisation-previous-images').load($(document.body).data('base') +'/ajax/customisation/render-previous-images.php');
          $('.site-slider__examples').slick({
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          });
        }, 1000);
      }   
    },
    error: function (responseData) {
        console.log('Ajax request not recieved!');
    }
  });

});

$('.submit-text-customisation').on('click', function () {
  var selectedColour = $('select[name="chosen_colour"]').val();
  var selectedColourHex = $('select[name="chosen_colour"]').find(':selected').data('hex');
  var selectedFont = $('select[name="chosen_font"]').val();
  var imgFont = $('select[name="chosen_font"]').find(':selected').data('imgname');
  $('input[name="text[chosen_text_colour]"]').val(selectedColour);

  if($('input[name="customisation[text][chosen_text_colour]').length) {
    $('input[name="customisation[text][chosen_text_colour]').val(selectedColour);
  }

  $('.option-colour .colour').css('background-color', selectedColourHex);
  $('.colour-name').text(selectedColour);
  $('input[name="text[chosen_text_font]"]').val(selectedFont).trigger('change');;
  if($('input[name="customisation[text][chosen_text_font]').length) {
    $('input[name="customisation[text][chosen_text_font]').val(selectedFont);
  }

  $('.option-font .font').css('font-family', selectedFont);

  $('.font-name').attr('src', $(document.body).data('base') + '/images/site/' + imgFont + '.png');

  $('#changecolour').foundation('close');
});

//remove customisation
$('.remove-customisation').on('click', function(e) {
  e.preventDefault();
  var cart_id = $(this).data('cartid');
  var customisation_id = $(this).data('customisationid');
  var bundle_id = $(this).data('bundleid');

  $.ajax({
    type: 'post',
    url: $(document.body).data('base') +'/ajax/customisation/remove-customisation-from-cart.php',
    data: {
      cartid: cart_id,
      customisationid: customisation_id,
      bundleid: bundle_id
    },
    success: function (responseData) {
      var $response = JSON.parse(responseData);
      if (typeof $response === 'object' && $response !== null && $response['status'] !== 'success') {
        swal({
          title: $response['status'], 
          text: $response['message'],
          type: $response['status'],
          confirmButtonColor: "#f15a24"
        });
      } else {
        location.reload();
      }   
    },
    error: function (responseData) {
        console.log('Ajax request not recieved!');
    }
  });
});

//When current session uploaded image is selected, add to customisation and remove setup fee
$('.customise__currentuploaded img').on('click', function () {

  var url = $(this).attr('src');
  var inputToChange = $('input[name="image[uploaded_image_url]"]');

  inputToChange.val(url);

  //remove all current selections, dont allow more than one
  $('.customise__currentuploaded img').each(function(){
    $(this).removeClass('selected');
  })

  $(this).addClass('selected');

  calculatePrices();

});

$('.view-uploaded-logo').slickLightbox({
  itemSelector        : 'a',
  navigateByKeyboard  : true
});

$('.add-new-customisation').on('click', function(e) {
  e.preventDefault();
  $('form[name="customisation_form"]').find('input[name="add_new_customisation"]').val('1');
  $('form[name="customisation_form"]').submit();
});

})

//outside doc ready
$('.upload__right').on('click','.select_previous_image', function(){
  var checkbox = $(this).parent().find('input[type="checkbox"]');

  //remove uplaoded image
  $('input[name="image[uploaded_image_url]"]').val('');
  $('.form__input--upload').val('');
  $('.uploaded_preview').addClass('hidden');

  $('.select_previous_image').each(function(){
    if ( $(this).hasClass('selected') ) {
      $(this).removeClass('selected');
    }
  })

  $(this).addClass('selected');

  //deselect other existing images
  $('input[name="image[existing_id]"]').each(function(){
    if ( $(this).is(":checked") ) {
        $(this).prop('checked', false); 
    }
  })
  //select existing image thats been clicked on
  checkbox.prop('checked', true);

  calculatePrices();
})